import { create } from 'zustand';

const initialState = {
  isOpenTooltip: false,
};

export const useTooltip = create((set) => ({
  ...initialState,
  onOpenTooltip: (newState) => set((state) => ({ ...state, ...newState, isOpenTooltip: true })),
  onCloseTooltip: () => set(() => ({ ...initialState })),
}));
